import React from "react";

import { FormControlLabel, Switch } from "@material-ui/core/index";
import { withStyles } from "@material-ui/core/styles";

import styles from "./SwitchButton.module.scss";

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 56,
    height: 32,
    padding: 0,
    margin: 0,
  },
  switchBase: {
    padding: "4px",
    "&$checked": {
      transform: "translateX(24px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#72B033",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 32 / 2,
    backgroundColor: "#2C2C34",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
    }}
    {...props}
  />
));

const SwitchButton = ({
  checked,
  handleChange,
  disabled,
  name,
}) => (
  <FormControlLabel
    className={styles.switchButton}
    control={(
      <IOSSwitch
        checked={checked}
        onChange={handleChange}
        name={name}
        disabled={disabled}
      />
    )}
  />
);

export default SwitchButton;
